var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-select",class:[
      {
        'is-inline': _vm.inline,
        'is-disabled': _vm.disabled,
        'ui-input-group': _vm.$slots.prepend || _vm.$slots.append,
        'ui-input-group--append': _vm.$slots.append,
        'ui-input-group--prepend': _vm.$slots.prepend,
      }
    ]},[(_vm.$slots.prepend)?_c('div',{staticClass:"ui-input-group__prepend"},[_vm._t("prepend")],2):_vm._e(),_c('select',_vm._b({ref:"input",staticClass:"ui-select__inner uk-select",class:_vm.inputClass,style:(_vm.inputStyle),attrs:{"id":_vm.computedId,"disabled":_vm.disabled},domProps:{"value":_vm.currentValue},on:{"input":_vm.handleInput,"change":_vm.handleChange,"blur":_vm.handleBlur}},'select',_vm.$attrs,false),_vm._l((_vm.options),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label))])}),0),(_vm.$slots.append)?_c('div',{staticClass:"ui-input-group__append"},[_vm._t("append")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }